import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const Cell = ({ v, on, id }) => <input value={v} onChange={(e) => on(e.target.value)} className="field-bare w-full border border-slate-300 rounded px-2 py-1.5 text-sm focus:border-[#2563EB] outline-none" data-testid={id} />;

export const AdminSizeGuide = () => {
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/size-guide").then((r) => setG(r.data)); }, []);
  if (!g) return null;
  const set = (i, k, v) => setG({ ...g, rows: g.rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)) });
  const save = async () => {
    try { await api.put("/admin/size-guide", g); toast.success("Guía de tallas guardada"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="border border-slate-200 rounded p-4 mb-8" data-testid="admin-size-guide">
      <h3 className="font-display font-bold text-xl text-[#0B1D3A] mb-3">Guía de tallas (chaqueta y camiseta)</h3>
      <div className="grid grid-cols-[80px_1fr_1fr] gap-2 text-xs font-bold text-slate-500 mb-1"><span>Talla</span><span>Pecho (cm)</span><span>Largo (cm)</span></div>
      {g.rows.map((r, i) => (
        <div key={i} className="grid grid-cols-[80px_1fr_1fr] gap-2 mb-2">
          <Cell v={r.size} on={(v) => set(i, "size", v)} id={`admin-size-${i}-size`} />
          <Cell v={r.chest} on={(v) => set(i, "chest", v)} id={`admin-size-${i}-chest`} />
          <Cell v={r.length} on={(v) => set(i, "length", v)} id={`admin-size-${i}-length`} />
        </div>
      ))}
      <textarea value={g.note} onChange={(e) => setG({ ...g, note: e.target.value })} rows={2} className="w-full border border-slate-200 rounded px-2 py-1.5 text-sm mt-2" data-testid="admin-size-note" />
      <button onClick={save} className="mt-3 bg-[#0B1D3A] hover:bg-[#DC2626] text-white text-sm font-bold px-5 py-2 rounded-full transition-colors" data-testid="admin-size-save">Guardar guía</button>
    </div>
  );
};
